(function(){
     'use strict';

     angular
        .module('appback')
        .factory('SerotecaService', SerotecaService);

    SerotecaService.$inject = ['$http'];

    function SerotecaService($http){

        var service= {
           getSerotecas:getSerotecas,
           saveSoportes:saveSoportes,
           buscarMuestra:buscarMuestra,
           printRack:printRack
        };

        return service;
 		function getSerotecas(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/seroteca/getserotecas', { params : { filtros : filtros } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function printRack(rack,subrack,posicion,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/seroteca/printrack', { params : { posicion:posicion,subrack : JSON.stringify(subrack),rack : JSON.stringify(rack) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function buscarMuestra(id_muestra,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/seroteca/buscarmuestra', { params : { id_muestra : id_muestra } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function saveSoportes(congelador,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               congelador:JSON.stringify(congelador)
            });
            $http.post('/backend/seroteca/savesoportes', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
      
    }
})();